import { INIT_PLAYER, INIT_SIGNOUT, INIT_CHAPTER_LIST, CHANGE_ACTIVE_MODULE, DESTROY_PLAYER, UPDATE_MODULE_COMPLETED } from '../Actions/actionTypes';

const INIT_STATE = {};

const Player = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_PLAYER:
      return {
        ...state,
        courseID: action.courseID,
        chapterID: action.chapterID,
        moduleID: action.moduleID,
        slug: action.slug,
      };

    case INIT_SIGNOUT:
      return INIT_STATE;

    case INIT_CHAPTER_LIST:
      return {
        ...state,
        chapterList: action.chapters,
      };

    case CHANGE_ACTIVE_MODULE:
      return {
        ...state,
        chapterID: action.chapterID,
        moduleID: action.moduleID,
      };

    case UPDATE_MODULE_COMPLETED:
      return {
        ...state,
        chapterList: state.chapterList.map((chapter) => {
          if (action.chapterID === chapter._id) {
            return {
              ...chapter,
              modules: chapter.modules.map((module) => {
                if (action.moduleID === module._id) {
                  return { ...module, completed: true };
                } else return module;
              }),
            };
          }
          return chapter;
        }),
      };

    case DESTROY_PLAYER:
      return INIT_STATE;

    default:
      return state;
  }
};

export default Player;
